module.exports = __webpack_public_path__ + "static/media/400085_02.1497e1d7.png";